module.exports = __webpack_public_path__ + "static/media/gun_isolated2.a3e4d04a.png";